<div class="d-flex">
    <button type="button" class="icon-btn fill-valyrianSteel fill-hover-whaleTail" [popover]="popoverTemplate" #actionPopover="bs-popover"
        triggers="manual" container=".cx-one-ui" [outsideClick]="true" containerClass="cxone-popover" (click)="showPopover($event);">
        <svg class="icon-16">
            <use href="../App_Themes/clearview-default/icons/utility/more.svg#more"></use>
        </svg>
        <ng-template #popoverTemplate>
            <div class="more-option-popover">
                <ul>
                    <li class="clickable" id="edit-action-btn" (click)="editClick()">
                        <svg class="icon-16">
                            <use href="../App_Themes/CXone/icons/edit.svg#edit"></use>
                        </svg>
                        <span class="more-option-text" cvLocalizedText langSection="CXOne_Objectives"
                            langKey="Edit">Edit</span>
                    </li>
                    <li class="clickable" id="delete-action-btn" (click)="deleteClick(popoverRef)"
                        [ngbPopover]="objectiveDeleteModal" triggers="manual" container="body" placement="left"
                        #popoverRef="ngbPopover" popoverClass="cxoneObjectivesDeletePopover">
                        <svg class="icon-16">
                            <use href="../App_Themes/CXone/icons/delete.svg#delete"></use>
                        </svg>
                        <span class="more-option-text" cvLocalizedText langSection="CXOne_Objectives"
                            langKey="Delete">Delete</span>
                    </li>
                </ul>
            </div>
        </ng-template>
    </button>
    <ng-template #objectiveDeleteModal>
        <div class="color-white">
            <div cvLocalizedText langSection="CXOne_Objectives" langKey="Objective_Delete_Confirm_1">Deleting objectives
                may affect associated dashboards.</div>
            <div class="mt-2" cvLocalizedText langSection="CXOne_Objectives" langKey="Objective_Delete_Confirm_2">Are
                you sure you want to delete the objective?</div>

            <div class="d-flex justify-content-end mt-3">
                <button type="button" class="btn-medium btn-popover color-white mr-2"
                    style="height:28px; width:max-content" cvLocalizedText langSection="Common"
                    langKey="Cancel_Button">Cancel</button>
                <button type="button" class="btn-medium btn-primary" style="height:28px; width:max-content"
                    (click)="confirmDelete()" cvLocalizedText langSection="Common" langKey="Delete">Delete</button>
            </div>
        </div>
    </ng-template>
</div>